<template>
  <div class="hero">
    <v-row wrap class="hero_main">
      <v-carousel
        hide-delimiters
        :show-arrows="false"
        cycle
        continuous
        :height="getCarouselHeight"
      >
        <v-carousel-item eager v-for="(item, i) in citems" :key="i">
          <!-- <v-img :src="item.src" height="100vh" eager  style="filter: grayscale(100%);"/> -->
          <v-img
            class="carousel_img"
            :src="item.src"
            :height="getCarouselHeight"
            eager
          />
        </v-carousel-item>
      </v-carousel>
      <!-- <img src="/hero/main.jpeg" alt="Team Jazzterdays"> -->
    </v-row>

    <Header
      v-bind:header="header"
      :class="headclass"
      class="pb-16 pb-xl-0 pb-lg-0 pb-md-0 pd-sm-0"
    ></Header>
    <v-container class="non_bg">
      <MediumHeader v-bind:medheader="medheader"></MediumHeader>

      <v-row
        class="justify-center justify-xl-end justify-lg-end justify-md-end"
      >
        <v-col :cols="12" xl="10" lg="9" md="9" sm="8">
          <VideoTile
            v-bind:video="video"
            class="overtile withShaddow"
          ></VideoTile>
        </v-col>
        <v-col :cols="12" xl="9" lg="9" md="9" sm="8">
          <h3
            class="video_caption text-right overtile_video top_space"
            v-html="caption"
          ></h3>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      class="light_bg top_space_more noverflow_ma pb-md-16 mb-16 bottom_space_more notecontainer"
    >
      <!-- <NoteTriangle v-bind:config="noteTriangle1"></NoteTriangle>
        <NoteTriangle v-bind:config="noteTriangle2"></NoteTriangle>
        <NoteTriangle v-bind:config="noteTriangle3"></NoteTriangle> -->
      <!-- <NoteCircle v-bind:config="noteCircle1"></NoteCircle> -->
      <NoteCircle v-bind:config="noteCircle2"></NoteCircle>
      <!-- <NoteCircle v-bind:config="noteCircle3"></NoteCircle> -->

      <v-row class="justify-start quicklink">
        <v-col
          :cols="6"
          xl="12"
          lg="12"
          md="12"
          sm="6"
          xs="6"
          class="justify-start"
        >
          <v-hover>
            <a
              v-if="hover"
              slot-scope="{ hover }"
              class="linkText"
              href="#news"
            >
              <button class="is_hover">
                <v-img
                  class="d-inline-block align_button"
                  :width="getImgWidth"
                  :src="'/hero/down_arrow_bold3_highlighted.png'"
                >
                </v-img>
                neues
              </button>
            </a>
            <a v-else class="linkText" href="#news">
              <button>
                <v-img
                  class="d-inline-block align_button"
                  :width="getImgWidth"
                  :src="'/hero/down_arrow_bold3.png'"
                >
                </v-img>
                neues
              </button>
            </a>
          </v-hover>
        </v-col>
        <v-col
          :cols="12"
          xl="2"
          lg="2"
          md="2"
          sm="2"
          class="hidden-sm-and-down justify-start"
        ></v-col>

        <v-col
          :cols="6"
          xl="6"
          lg="6"
          md="6"
          sm="6"
          xs="6"
          class="justify-start"
        >
          <v-hover>
            <a
              v-if="hover"
              slot-scope="{ hover }"
              class="linkText"
              href="#dates"
            >
              <button class="is_hover">
                <v-img
                  class="d-inline-block align_button"
                  :width="getImgWidth"
                  :src="'/hero/down_arrow_bold3_highlighted.png'"
                >
                </v-img>
                termine
              </button>
            </a>
            <a v-else class="linkText" href="#dates">
              <button>
                <v-img
                  class="d-inline-block align_button"
                  :width="getImgWidth"
                  :src="'/hero/down_arrow_bold3.png'"
                >
                </v-img>
                termine
              </button>
            </a>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
import Header from "./Header.vue";
import MediumHeader from "./MediumHeader.vue";
import VideoTile from "./VideoTile.vue";
// import NoteTriangle from "./NoteTriangle.vue";
import NoteCircle from "./NoteCircle.vue";

export default {
  name: "Hero",
  components: {
    MediumHeader,
    Header,
    VideoTile,
    // NoteTriangle,
    NoteCircle,
  },
  computed: {
    getButton() {
      return "/hero/down_arrow_bold3.png";
    },
    getImgWidth() {
      const { smAndDown } = this.$vuetify.breakpoint;
      return smAndDown ? 50 : 70;
    },
    getCarouselHeight() {
      const { smAndDown } = this.$vuetify.breakpoint;
      return smAndDown ? "50vh" : "100vh";
    },
  },
  data() {
    return {
      headclass: "narrow",
      button: "/hero/down_arrow_bold3.png",
      button_hightlight: "'/hero/down_arrow_bold3_highlighted.png'",
      noteTriangle1: {
        id: "t1",
        width: 150,
        top: 350,
        left: 50,
        style: "stroke-dasharray: 1;",
        transform:
          "translateY(calc(calc(calc(var(--parallax-value) * 1px)) - 320px)) rotateZ(calc(var(--parallax-value) * -1.5deg))",
        strokeWidth: 10,
        maxLimit: 680,
        minLimit: 200,
      },
      noteTriangle2: {
        id: "t2",
        width: 300,
        top: 50,
        left: 100,
        style: "stroke-dasharray: 1;",
        transform:
          "translateX(calc(calc(calc(var(--parallax-value) * -3.5px)) + 500px)) rotateZ(calc(var(--parallax-value) * 0.5deg))",
        strokeWidth: 7,
        maxLimit: 480,
        minLimit: 220,
      },
      noteTriangle3: {
        id: "t3",
        width: 200,
        top: 120,
        left: 250,
        style: "stroke-dasharray: 1;",
        strokeWidth: 10,
        transform:
          "translateX(calc(calc(calc(var(--parallax-value) * 1.5px)) - 200px)) rotateZ(calc(var(--parallax-value) * -0.7deg))",
        maxLimit: 400,
        minLimit: 220,
      },
      noteCircle1: {
        id: "c1",
        width: 350,
        top: 360,
        left: -160,
        style: "stroke-dasharray: 0.5;",
        strokeWidth: 7,
        transform:
          "translate(calc(calc(calc(var(--parallax-value) * 0px)) - 20px), calc(var(--parallax-value) * -1px))",
        maxLimit: 660,
        minLimit: 300,
      },
      noteCircle2: {
        id: "c2",
        width: 270,
        top: 230,
        left: 20,
        style: "stroke-dasharray: 0.5;",
        strokeWidth: 4,
        transform: "scale(calc(calc(var(--parallax-value) / 100) * 1.4))",
        maxLimit: 660,
        minLimit: 200,
      },
      noteCircle3: {
        id: "c3",
        width: 120,
        top: 240,
        left: 160,
        style: "stroke-dasharray: 0.5;",
        strokeWidth: 7,
        transform: "scale(calc(calc(var(--parallax-value) / 100) * 0.9))",
        // "translate(calc(calc(calc(var(--parallax-value) * 1px)) - 20px), calc(var(--parallax-value) * -1px)) rotateZ(calc(var(--parallax-value) * -0.7deg))",
        maxLimit: 460,
        minLimit: 0,
      },
      video: {
        id: "vid1",
        url: "/hero/JAZZTERDAYS in Halle 424.mp4",
        poster: "/hero/poster.png",
      },
      citems: [
        { src: "/hero/main.jpg" },
        { src: "/hero/main2.jpg" },
        { src: "/hero/main3_LQ.png" },
        { src: "/hero/main4.jpg" },
        { src: "/hero/main5.jpg" },
        // { src: '/hero/main6.jpg'}, sw gruppenbild
        // { src: '/hero/main7.jpg'}, 3er foto
        { src: "/hero/main8_LQ.png" },
      ],
      header: "Jazzterdays",
      medheader: "Zeitreise zu den Legenden des Jazz",
      subheader: "INSZENIERTE LESUNG MIT LIVE-MUSIK",
      caption: "HALLE 424, HAMBURG",
    };
  },
};

// var runRepeatedly = function(note) {
//   console.log("once");
//   setInterval(test(note), 1000);
// }

// var test = function (note) {
//   console.log("now");
//   // note.style.transform = "translateX(calc(--parallax-value * 3px)";
//   note.style.transform = "translateX(200px)";
// };
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Fauna+One&display=swap");
@import url("https://db.onlinewebfonts.com/c/dd4cd94627c61f898bfd2ee76483fa85?family=Gill+Sans+Nova");
@import url("https://fonts.googleapis.com/css2?family=Teko:wght@700&display=swap");
@import "~vuetify/src/styles/settings/_variables.scss";

.carousel_img {
  filter: blur(0px) grayscale(100%);
  animation-name: image_blur;
  animation-duration: 4s;
  animation-delay: 0.5s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}

@keyframes image_blur {
  0% {
    -webkit-filter: blur(0px) grayscale(100%);
  }
  100% {
    -webkit-filter: blur(4px) grayscale(100%);
  }
}

.notecontainer {
  position: relative;
}

.hero_main {
  img {
    width: 100%;
  }
  position: relative;
  z-index: 2;
}

.bdottom_space_more {
  @media #{map-get($display-breakpoints, 'xl-only')} {
    padding-bottom: 200px;
  }

  @media #{map-get($display-breakpoints, 'lg-only')} {
    padding-bottom: 150px;
  }
}

.video_caption {
  color: #707070;
  opacity: 0.5;
  font-family: "Teko", sans-serif;
  font-size: 2.5rem;
  z-index: 1;
}

.overtile {
  position: relative;
  bottom: -200px;
  overflow: overlay;
  margin-top: -200px;
}

.overtile_video {
  position: relative;
  bottom: -300px;
  overflow: overlay;
  margin-top: -250px;
}

.withShaddow {
  box-shadow: -26px 29px 13px -6px rgba(0, 0, 0, 0.6);
}

.backendText {
  font-family: "Gill Sans Nova", serif;
  font-size: 5rem;
  color: #37383a;
  opacity: 0.2;
}

.quicklink {
  a {
    cursor: pointer;
  }
  text-align: center;

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    text-align: left;
  }
}

@import url("https://fonts.googleapis.com/css2?family=Teko:wght@700&display=swap");
.linkText {
  color: #707070;
  // color: #252323;
  font-family: "Teko", sans-serif;
  text-decoration: unset;
  font-size: 1.8rem;
  // transform: rotate(90deg);

  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    font-size: 2.5rem;
  }

  .is_hover {
    color: #1765b3;
  }
}

.align_button {
  vertical-align: middle;
  margin-right: 5px;
}
</style>